<dashboardnav>
  <cradua-subsubgrouptype
  [subsubgrouptypes]="subsubgrouptypes$ | async"
  (subsubgrouptype)="onSubmitSubSubGroupType($event)"
  (deleteSubSubGroupTypeEvent)="onDeleteSubSubGroupType($event)"
  *ngIf="(isLoadingSubSubGroupType$ | async ) === false"
  >
</cradua-subsubgrouptype>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingSubSubGroupType$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
